export const TYPE_ABBREVIATIONS = {
  'Summary Plan Description (SPD)': 'SPD',
  'Investment Policy Statement (IPS)': 'IPS',
  'Summary Annual Report (SAR)': 'SAR',
  'Quarterly/Annual Performance Reports': 'Performance Reports',
  'Participant Fee Disclosure': 'Fee Disclosure',
  'Fiduciary Audit Checklist': 'Audit Checklist',
  'Hardship Withdrawal Requests': 'Hardship Requests',
  'Board Resolutions Related to the Plan': 'Board Resolutions',
  'Compliance Testing Results': 'Compliance Tests',
  'Annual Plan Review': 'Annual Review',
  'Adoption Agreement': 'Adoption Agree...',
};

export const DOCUMENT_TYPES = [
  'Adoption Agreement',
  'Annual Plan Review',
  'Benefit Statements',
  'Board Resolutions Related to the Plan',
  'Census Data Reports',
  'Compliance Testing Results',
  'Contribution Reports',
  'Corrective Action Documentation',
  'Custodial Agreement',
  'DOL/IRS Correspondence',
  'Distribution Forms',
  'Eligible Employee Notification',
  'ERISA Fidelity Bond Documentation',
  'Expense Reimbursement Records',
  'Fee Benchmarking Reports',
  'Fiduciary Audit Checklist',
  'Fiduciary Responsibility Documentation',
  'Form 1099-R (Distributions)',
  'Form 5500',
  'Hardship Withdrawal Requests',
  'Investment Change Notices',
  'Investment Monitoring Reports',
  'Investment Performance Reports',
  'Investment Policy Statement (IPS)',
  'IRS Determination Letter',
  'Loan Request Forms',
  'Participant Complaints & Resolutions',
  'Participant Education Materials',
  'Participant Fee Disclosure',
  'Participant Loan Records',
  'Participant Notices (e.g., Safe Harbor, QDIA)',
  'Participant Termination Notices',
  'Plan Amendments',
  'Plan Audit Reports',
  'Plan Compliance Checklists',
  'Plan Design Documentation',
  'Plan Document',
  'Plan Enrollment Kit',
  'Plan Health Report',
  'Plan Highlights',
  'Plan Restatement Documents',
  'Plan Sponsor Meeting Minutes',
  'Quarterly/Annual Performance Reports',
  'Recordkeeper & TPA Correspondence',
  'Regulatory Filing Confirmations',
  'Rollover Acknowledgment Forms',
  'Safe Harbor Notices',
  'Service Agreements',
  'Summary Annual Report (SAR)',
  'Summary of Material Modifications (SMM)',
  'Summary Plan Description (SPD)',
  'Testing & Coverage Results',
  'Trust Agreement',
  'Vendor Fee Disclosures'
];